import { AuditDateTimeRangeFields } from '../../../../components/AuditDateTimeRangeFields';

export function AdOverlayForm() {
  return <AuditDateTimeRangeFields />;
}
